import { MedicalTypeBaseUrlMap } from "@qendo/medical";
import { MedicalIconMap, MedicalOptionTypeMap, type MedicalType } from "@qendo/medical/types";
import { useMemo } from "react";
import { ListingItem, type ListingItemProps } from "~/components/layout/ListingItem";
import { useMedical } from "~/providers/MedicalProvider";
import { useOptions } from "~/providers/OptionsProvider";

type MedicalListingItemProps = {
    readonly type: MedicalType;
    title: string;
} & Omit<ListingItemProps, "icon" | "href" | "subtitle">;

export const MedicalListingItem = ({ type, title, ...props }: MedicalListingItemProps) => {
    const { listMedical } = useMedical();
    const { findOption } = useOptions();

    const subtitle = useMemo(() => {
        const option_type = MedicalOptionTypeMap[type];

        const items = listMedical(type);
        let total = items.length;
        let show = "";

        for (const item of items) {
            const next = findOption(option_type, item.option_id as string)?.title ?? "";

            if (show.length + next.length > 32) {
                show = `${show} +${total} more`;
                break;
            }

            show = [show, next].filter((s) => s.trim().length).join(", ");

            total--;
        }

        return show;
    }, [findOption, listMedical, type]);

    return (
        <ListingItem
            {...props}
            title={title}
            icon={MedicalIconMap[type]}
            subtitle={subtitle}
            href={MedicalTypeBaseUrlMap[type]}
        />
    );
};
